import { render, staticRenderFns } from "./AdminFinalExamSettingsDate.vue?vue&type=template&id=1a6cb95a"
import script from "./AdminFinalExamSettingsDate.vue?vue&type=script&lang=js"
export * from "./AdminFinalExamSettingsDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports